import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { Building, ServerCrash } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { Toast } from '@/common/components/Toast'
import { api, ApiError } from '@/lib/axios'
import { queryClient } from '@/lib/tanstack'
import { NewAccountForm } from '../schemas/NewAccountSchema'

async function postNewAccount(data: NewAccountForm) {
  return api.backend.post('/account', data)
}

export function useNewAccount() {
  const { t } = useTranslation('sso')

  const { mutateAsync, isPending } = useMutation<
    unknown,
    AxiosError<ApiError>,
    NewAccountForm
  >({
    mutationKey: ['/account'],
    mutationFn: postNewAccount,
    onSuccess: () => {
      toast(Toast, {
        data: {
          type: 'success',
          icon: Building,
          title: t('accounts.drawer_new_account.toast_success.title'),
        },
      })
      queryClient.invalidateQueries({ queryKey: ['/account/paginate'] })
    },
    onError: (error) => {
      toast(Toast, {
        data: {
          type: 'danger',
          icon: ServerCrash,
          title: t('accounts.drawer_new_account.toast_error.title'),
          description:
            error?.response?.data?.friendlyMessage ||
            t('accounts.drawer_new_account.toast_error.description'),
        },
      })
    },
  })

  const handleCreateAccount = async (data: NewAccountForm) => {
    return mutateAsync(data)
  }

  return { handleCreateAccount, isCreatingAccount: isPending }
}
